import { computed, isRef, type Ref, type ComputedRef } from "vue";
import { useStore } from "vuex";
import dayjs from "dayjs";
import { PlanEspecial } from "@/app/common/types";

type RangeType = "days" | "months";

export const usePlanDateRangeValidation = (
  rangeLimit: Ref<number> | ComputedRef<number> | number,
  typeRange: Ref<RangeType> | ComputedRef<RangeType> | RangeType
) => {
  const store = useStore();

  const userData = computed(() => store.getters["getDataUser"]);

  const isUnlimited = computed(
    () => userData.value?.change_custom_plan?.plan === PlanEspecial
  );

  const limit = computed(() =>
    isRef(rangeLimit) ? rangeLimit.value : rangeLimit
  );

  const type = computed(() =>
    isRef(typeRange) ? typeRange.value : typeRange
  );

  const normalizeDate = (date: any) => {
    if (!date) return null;

    // Ya es Dayjs
    if (dayjs.isDayjs(date)) {
      return date;
    }

    // String o Date
    return dayjs(date);
  };

  const isOutOfRange = (startDate: any, endDate: any) => {
    const start = normalizeDate(startDate);
    const end = normalizeDate(endDate);

    if (!start || !end) return false;

    // Plan ilimitado
    if (isUnlimited.value) {
      return false;
    }

    const diff = end.diff(start, typeRange.value, true);

    return diff > rangeLimit.value;
  };

  const isInvalidRange = (
    startDate: any,
    endDate: any,
    allowSameDate = true
  ) => {
    const start = normalizeDate(startDate);
    const end = normalizeDate(endDate);

    if (!start || !end) return false;

    const invalidOrder = allowSameDate
      ? start.valueOf() > end.valueOf()
      : start.valueOf() >= end.valueOf();

    if (invalidOrder) {
      return true;
    }

    // Plan ilimitado
    if (isUnlimited.value) {
      return false;
    }

    const diff = end.diff(start, type.value, true);

    return diff > limit.value;
  };

  return {
    isOutOfRange,
    isUnlimited,
    isInvalidRange,
  };
};